import { render, staticRenderFns } from "./CenterSidebarForm.vue?vue&type=template&id=3f2c470a&scoped=true&"
import script from "./CenterSidebarForm.vue?vue&type=script&lang=js&"
export * from "./CenterSidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./CenterSidebarForm.vue?vue&type=style&index=0&id=3f2c470a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c470a",
  null
  
)

export default component.exports